import React from 'react';
import { TextField, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';

import useStyles from './useStyles';

const ResetPasswordForm = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onSubmit, initialValues, validationSchema } = props;

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleBlur, touched, handleSubmit, setValues } = formik;

  const isAbleToSubmit = isEmpty(errors);

  const handleCancel = () => {
    setValues(initialValues);
  };

  return (
    <div className={classes.container}>
      <form onSubmit={handleSubmit}>
        <div className={classes.formGroup}>
          <TextField
            error={touched.currentPassword && Boolean(errors.currentPassword)}
            helperText={touched.currentPassword && t(errors.currentPassword)}
            variant="outlined"
            label={t('components.LoanOfficerSettings.ResetPasswordForm.fields.currentPassword.label')}
            id="currentPassword"
            name="currentPassword"
            autoComplete="current-password"
            className={classes.field}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.currentPassword}
            type="password"
            placeholder={t('components.LoanOfficerSettings.ResetPasswordForm.fields.currentPassword.placeholder')}
            FormHelperTextProps={{
              style: {
                marginLeft: 0,
              },
            }}
            InputProps={{
              style: {
                height: '40px',
              },
            }}
            InputLabelProps={{
              shrink: false,
            }}
          />
          <TextField
            error={touched.password && Boolean(errors.password)}
            helperText={touched.password && t(errors.password)}
            variant="outlined"
            label={t('components.LoanOfficerSettings.ResetPasswordForm.fields.newPassword.label')}
            id="password"
            name="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
            autoComplete="new-password"
            className={classes.field}
            type="password"
            placeholder={t('components.LoanOfficerSettings.ResetPasswordForm.fields.newPassword.placeholder')}
            FormHelperTextProps={{
              style: {
                marginLeft: 0,
              },
            }}
            InputProps={{
              style: {
                height: '40px',
              },
            }}
            InputLabelProps={{
              shrink: false,
            }}
          />
          <TextField
            error={touched.passwordConfirmation && Boolean(errors.passwordConfirmation)}
            helperText={touched.passwordConfirmation && t(errors.passwordConfirmation)}
            variant="outlined"
            label={t('components.LoanOfficerSettings.ResetPasswordForm.fields.passwordConfirmation.label')}
            id="passwordConfirmation"
            name="passwordConfirmation"
            autoComplete="new-password"
            className={classes.field}
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.passwordConfirmation}
            placeholder={t('components.LoanOfficerSettings.ResetPasswordForm.fields.passwordConfirmation.placeholder')}
            FormHelperTextProps={{
              style: {
                marginLeft: 0,
              },
            }}
            InputProps={{
              style: {
                height: '40px',
              },
            }}
            InputLabelProps={{
              shrink: false,
            }}
          />
        </div>
        <div className={classes.buttons}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            type="submit"
            disabled={!isAbleToSubmit}
          >
            {t('components.LoanOfficerSettings.ResetPasswordForm.buttons.save')}
          </Button>
          <Button variant="outlined" color="primary" className={classes.button} type="button" onClick={handleCancel}>
            {t('components.LoanOfficerSettings.ResetPasswordForm.buttons.cancel')}
          </Button>
        </div>
      </form>
    </div>
  );
};

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape().isRequired,
  validationSchema: PropTypes.shape().isRequired,
};

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/ResetPassword/components/ResetPasswordForm/ResetPasswordForm.js